import gsap from "gsap";

export const lineAnimation = () =>
  gsap
    .timeline({ repeat: -1, repeatDelay: 5 })
    .fromTo(
      ".js-rect",
      {
        strokeDashoffset: 1050,
      },
      {
        delay: 1,
        strokeDashoffset: 0,
        duration: 1.4,
        ease: "power3.in",
      }
    )
    .to(
      ".js-rect",
      {
        strokeDashoffset: -1050,
        duration: 1.4,
        ease: "power3.out",
      },
      "+=0.3"
    );
